<app-card-relatorio-laudo *ngIf="elementsSuccess.length > 0" [titulo]="'ITENS APROVADOS'" [status]="1">
    <ul class="card-list card-list-success">
        <li *ngFor="let e of elementsSuccess"> <span> {{e.value}} </span> </li>
    </ul>
</app-card-relatorio-laudo>


<app-card-relatorio-laudo *ngIf="elementsWarning.length > 0" [titulo]="'ITENS DE ALERTA'" [status]="3" >
    <ul class="card-list card-list-warning">
        <li *ngFor="let e of elementsWarning"> <span> {{e.value}} </span> </li>
    </ul>
</app-card-relatorio-laudo>

<app-card-relatorio-laudo *ngIf="elementsDanger.length > 0" [titulo]="'ITENS REPROVADOS'" [status]="5">
    <ul class="card-list card-list-danger">
        <li *ngFor="let e of elementsDanger"> <span> {{e.value}} </span> </li>
    </ul>
</app-card-relatorio-laudo>